type AnyObj = Record<string, any>;

/** RTDB `push()` stores a map keyed by push-id; Firestore stores a real array. Accept both. */
const asArray = (v: any): AnyObj[] =>
  Array.isArray(v) ? v : v && typeof v === 'object' ? Object.values(v) : [];

/**
 * Every package a client has bought, de-duplicated.
 *
 * A single purchase is written to BOTH `purchasedPackage` (the latest) and
 * `purchasedPackages` (the history) — see backend/routes/auth.js, which does a
 * `.set()` on one and a `.push()` on the other with the same payload. Callers that
 * concatenated the two therefore showed the newest purchase twice. Keying on the
 * fields that identify a purchase collapses that, while still surfacing the legacy
 * single field for older users who never got a history entry.
 */
export function purchasedPackages(u: AnyObj | null | undefined): AnyObj[] {
  const all = [
    ...asArray(u?.purchasedPackages),
    ...(u?.purchasedPackage && u.purchasedPackage.name ? [u.purchasedPackage] : []),
  ].filter(p => p && p.name);

  const seen = new Set<string>();
  return all.filter(p => {
    const key = [
      p.name,
      p.purchasedAt ?? '',
      p.band ?? '',
      p.price ?? '',
      Array.isArray(p.flags) ? p.flags.join('') : '',
    ].join('|');
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
